import { Component, Inject } from '@angular/core';
import { MAT_DIALOG_DATA } from '@angular/material/dialog';
import { combineAll, DcBaseComponent } from '@datachain/ui-sdk/common';
import {
	AppModalService,
	ModalData,
} from '@datachain/ui-sdk/components/app-modal';
import { Observable } from 'rxjs';

import { DcIcons } from '../../../ui/app-dc.icons';

export enum DepotAction {
	Delete = 'delete',
}

export interface IDepotActionModalData {
	depotId: number | Array<number>;
	element: string;
	action: DepotAction;
}
@Component({
	selector: 'app-depot-action-popup',
	templateUrl: './depot-action-popup.component.html',
	styleUrls: ['./depot-action-popup.component.scss'],
})
export class DepotActionPopupComponent<
	T extends IDepotActionModalData
> extends DcBaseComponent {
	public readonly Icons = DcIcons;
	public vo$: Observable<{
		element: string;
		depotId: number | Array<number>;
		isMultipleElement: boolean;
		action: DepotAction;
	}>;
	public confirmDeletion = false;

	protected readonly DcIcons = DcIcons;
	protected readonly DepotAction = DepotAction;
	public constructor(
		private readonly modalService: AppModalService,
		@Inject(MAT_DIALOG_DATA) public readonly modalData: ModalData & T
	) {
		super();
		this.cmpId = 'depot-action';

		this.vo$ = combineAll({
			element: this.modalData.element,
			isMultipleElement:
				Array.isArray(this.modalData.depotId) && this.modalData.element === '',
			depotId: this.modalData.depotId,
			action: this.modalData.action,
		});
	}

	public confirmAction(): void {
		this.modalService.closeActiveModal({
			shouldLaunch: true,
		});
	}
}
